// extracted by mini-css-extract-plugin
export default {"printDoc":"cprint_printDoc__Y3myO","s1":"cprint_s1__1NFwD","s2":"cprint_s2__4bEmh","s3":"cprint_s3__3cyO+","l1":"cprint_l1__fYmkP"};